import request from '@/utils/request'

export function getHotelStatus(query) {
  return request({
    url: '/booking-service/v1/receptionist/hotel-status',
    method: 'get',
    params: query
  })
}
